import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { BiRefresh } from 'react-icons/bi';
import SearchBar from '../../components/searchBar/SearchBar';
import { getCbbos } from '../../services/fpo';
import { Link } from 'react-router-dom';
import Button from '../../components/buttons/Button';

function FpoCbbo() {
    const [searchText, setSearchText] = useState("");

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const headers = [
        { label: "Time", key: "updated_at" },
        { label: "Name", key: "name" },
        { label: "FPO Count", key: "fpo_count" },
        { label: "Action", key: "action" },
    ];

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getCbbos(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}`);
    };

    const resetFilters = () => {
        setSearchText("");
        fetchData("");
    };

    return (<>
        <div className="flex flex-row gap-2 items-center justify-between">
            <div className='flex gap-2 items-center'>
                <SearchBar
                    placeholder="Start typing here..."
                    onSearch={handleSearch}
                    value={searchText}
                />

                {/* Reset Filters Icon */}
                {(searchText.length !== 0) && (
                    <BiRefresh
                        size={24}
                        className="cursor-pointer text-primary"
                        onClick={resetFilters}
                    />
                )}
            </div>
            <Link to="/enquiries/fpos/cbbo/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add CBBO
                </Button>
            </Link>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.map((item, index) => (
                            {
                                name: <p>{item.name}</p>,
                                updated_at: <p>{item.updated_at}</p>,
                                fpo_count: <p>{item.fpo_count}</p>,
                                action: <Link to={`/enquiries/fpos/cbbo/${item.id}`} state={item} className='self-center'>
                                    <Button
                                        type="button"
                                        className="hover:bg-primary hover:opacity-70 text-white bg-primary/80 rounded-md"
                                    >
                                        Edit
                                    </Button>
                                </Link>,
                            }))}
                    />
                </div>}
    </>);
}

export default FpoCbbo;